import { render, staticRenderFns } from "./OficinasCaetanoRetailLogoPT.vue?vue&type=template&id=415de9cd&scoped=true&"
var script = {}
import style0 from "./OficinasCaetanoRetailLogoPT.vue?vue&type=style&index=0&id=415de9cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415de9cd",
  null
  
)

export default component.exports